import { isApolloError } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { redirectToAuth } from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';

import { toast } from '@eluve/components';

import { ErrorPage } from './ErrorPage';

export const ErrorFallbackRender: Sentry.FallbackRender = ({
  error,
  resetError,
}) => {
  if (isApolloError(error)) {
    resetError();
    Sentry.captureException(error);
    toast.error(
      'Your session has expired. Please re-authenticate to continue using Eluve.',
    );

    Session.signOut()
      .then(() => redirectToAuth({ redirectBack: true }))
      .catch((signOutError) => {
        Sentry.captureException(signOutError);
        toast.error('Failed to sign out. Please try again.');
      });
    // Sentry.FallbackRender requires Element to be returned
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return <ErrorPage reset={resetError} />;
};
